import { AddRoundedIcon, Button, type ButtonProps } from '@shared/components';

export default function AddQBankStructureButton(props: Readonly<ButtonProps>) {
  return (
    <Button variant='outlined' color='secondary' startIcon={<AddRoundedIcon />} {...props}>
      Add QBank
    </Button>
  );
}
